import React from 'react';

const Home = React.lazy(() => import('views/website/home').then(m => ({ default: m.Home })));
const Contact = React.lazy(() => import('views/website/contact').then(m => ({ default: m.Contact })));
const Pricing = React.lazy(() => import('views/website/pricing').then(m => ({ default: m.Pricing })));
const Terms = React.lazy(() => import('views/website/terms').then(m => ({ default: m.Terms })));
const Privacy = React.lazy(() => import('views/website/privacy').then(m => ({ default: m.Privacy })));

const Routes = [
  {
    path: '/',
    view: Home,
    layout: 'home',
    title: 'TRS Administrador'
  },
  {
    path: '/contact',
    view: Contact,
    layout: 'home',
    title: 'Contacto'
  },
  {
    path: '/pricing',
    view: Pricing,
    layout: 'home',
    title: 'Precios'
  },
  {
    path: '/privacy',
    view: Privacy,
    layout: 'home',
    title: 'Política de Privacidad'
  },
  {
    path: '/terms',
    view: Terms,
    layout: 'home',
    title: 'Términos y Condiciones'
  },
]

export default Routes;
